import { Component, Vue } from 'vue-property-decorator';

@Component
export default class MessageMixin extends Vue {
    public registerIsLoaded() {
        this.$store.commit('scroll/registerLoadedEvent');
    }
}
